import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack } from '@lyearn/ui';
import LessonDescription from '@/components/EditorViewer/LessonDescription';
import LessonTitle from '@/components/EditorViewer/LessonTitle';
import Editor from '@/components/PageEditor';
import useCourseEditorViewProps from '@/modules/corporate/modules/course/hooks/useCourseEditorViewProps';
import {
  EMPTY_LESSON_DESCRIPTION,
  EMPTY_LESSON_TITLE,
} from '@/modules/corporate/modules/course/views/CourseBuilder/components/Sidebar/stub';

function LessonContent({
  data,
  fetching,
  lesson,
}: {
  fetching: boolean;
  data: any;
  lesson: {
    id?: string;
    name?: string;
    description?: string;
  };
}) {
  const courseEditorProps = useCourseEditorViewProps();
  useTranslation('Course');

  const lessonTitle = lesson?.name ? lesson?.name : EMPTY_LESSON_TITLE;
  return (
    <Stack
      alignItems="center"
      className="w-full flex-1 overflow-y-auto pb-96 pt-32"
      direction="col">
      <Stack className={'max-w-[60rem]'} direction="col">
        <LessonTitle title={lessonTitle} />
        <LessonDescription
          description={lesson.description ?? ''}
          placeholder={EMPTY_LESSON_DESCRIPTION}
        />
        <Editor {...courseEditorProps} editable={false} jsonDoc={data} loading={fetching} />
      </Stack>
    </Stack>
  );
}

export default React.memo(LessonContent);
